// src/context/UiFeedbackContext.js
import { createContext, useCallback, useContext, useEffect, useState } from 'react'

const UiFeedbackContext = createContext(null)

export function UiFeedbackProvider({ children }) {
  const [toast, setToast] = useState(null)    // { title, message }
  const [visible, setVisible] = useState(false)

  const hide = useCallback(() => {
    setVisible(false)
  }, [])

  const show = useCallback((payload) => {
    setToast(payload)
    setVisible(true)
  }, [])

  // Notification spéciale pour "ajout au panier"
  const notifyAddToCart = useCallback((product, deltaQty = 1) => {
    if (!product || deltaQty <= 0) return
    const qty = Math.abs(deltaQty || 1)
    const name =
      product.title ||
      product.Name ||
      product.name ||
      'Produit'

    show({
      title: 'Ajouté au panier',
      message: `${name}  ×${qty}`,
    })
  }, [show])

  // auto-hide après 2,5s
  useEffect(() => {
    if (!visible) return
    const id = setTimeout(() => setVisible(false), 2500)
    return () => clearTimeout(id)
  }, [visible])

  return (
    <UiFeedbackContext.Provider value={{ notifyAddToCart }}>
      {children}

      {/* Toast flottant bas-centre */}
      <div
        aria-live="polite"
        aria-atomic="true"
        className="app-toast-wrapper"
      >
        {visible && toast && (
          <div className="app-toast shadow-lg">
            <div className="app-toast-body">
              <div className="d-flex justify-content-between align-items-start gap-2">
                <div>
                  <div className="fw-semibold small">
                    {toast.title}
                  </div>
                  <div className="small text-muted">
                    {toast.message}
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close btn-close-white btn-sm"
                  aria-label="Fermer"
                  onClick={hide}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </UiFeedbackContext.Provider>
  )
}

export function useUiFeedback() {
  return useContext(UiFeedbackContext) || {
    notifyAddToCart: () => {},
  }
}